module.exports = __webpack_public_path__ + "static/media/guide-smell-4.143a981b.svg";